export function optimizedImageUrl(url: string | null | undefined, width: number): string {
  if (!url) return "";
  if (!url.startsWith("/objects/")) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}w=${Math.round(width)}`;
}
